import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import UserProfileContext from 'on_web/context/userProfileContext';
import Question from 'on_web/components/shared/Question/Question';
import {
  getMedicationsQuestionsSwitch,
  getAceQuestions,
  getAceValuesArr,
  getArbQuestions,
  getArbValuesArr,
} from 'on_web/helpers/questions';

import { useTranslation } from 'react-i18next';

function DiseasesStep5(props) {
  const context = React.useContext(UserProfileContext);
  const [selected, setSelected] = useState(
    context && context.userMetaData
      ? context.userMetaData.bloodPressureMedication
      : undefined
  );

  const setAceValues = userAce => {
    userAce['benazepril'] =
      selectedAceItems.includes('1') && !noneAceSelected() ? 1 : 0;
    userAce['aptopril'] =
      selectedAceItems.includes('2') && !noneAceSelected() ? 1 : 0;
    userAce['enalapril'] =
      selectedAceItems.includes('3') && !noneAceSelected() ? 1 : 0;
    userAce['fosinopril'] =
      selectedAceItems.includes('4') && !noneAceSelected() ? 1 : 0;
    userAce['lisinopril'] =
      selectedAceItems.includes('5') && !noneAceSelected() ? 1 : 0;
    userAce['moexipril'] =
      selectedAceItems.includes('6') && !noneAceSelected() ? 1 : 0;
    userAce['perindopril'] =
      selectedAceItems.includes('7') && !noneAceSelected() ? 1 : 0;
    userAce['quinapril'] =
      selectedAceItems.includes('8') && !noneAceSelected() ? 1 : 0;
    userAce['ramipril'] =
      selectedAceItems.includes('9') && !noneAceSelected() ? 1 : 0;
    userAce['trandolapril'] =
      selectedAceItems.includes('10') && !noneAceSelected() ? 1 : 0;
    return userAce;
  };

  const setArbValues = userArb => {
    userArb['azilsartan'] =
      selectedArbItems.includes('1') && !noneArbSelected() ? 1 : 0;
    userArb['candesartan'] =
      selectedArbItems.includes('2') && !noneArbSelected() ? 1 : 0;
    userArb['eprosartan'] =
      selectedArbItems.includes('3') && !noneArbSelected() ? 1 : 0;
    userArb['irbesartan'] =
      selectedArbItems.includes('4') && !noneArbSelected() ? 1 : 0;
    userArb['telmisartan'] =
      selectedArbItems.includes('5') && !noneArbSelected() ? 1 : 0;
    userArb['valsartan'] =
      selectedArbItems.includes('6') && !noneArbSelected() ? 1 : 0;
    userArb['losartan'] =
      selectedArbItems.includes('7') && !noneArbSelected() ? 1 : 0;
    userArb['olmesartan'] =
      selectedArbItems.includes('8') && !noneArbSelected() ? 1 : 0;
    userArb['entresto'] =
      selectedArbItems.includes('9') && !noneArbSelected() ? 1 : 0;
    userArb['byvalson'] =
      selectedArbItems.includes('10') && !noneArbSelected() ? 1 : 0;
    return userArb;
  };

  const onClickNext = () => {
    const userMetadata = context ? context.userMetaData : null;
    const userAce = context ? context.userAce : null;
    const userArb = context ? context.userArb : null;

    if (props.onClickNext && userMetadata && userAce && userArb) {
      userMetadata.bloodPressureMedication = selected;

      if (selected === '1') {
        setAceValues(userAce);
        setArbValues(userArb);
      }

      if (selectedAceItems.includes('11') && selectedAceItems.length === 1) {
        userMetadata.medicationsAceNone = true;
      } else {
        userMetadata.medicationsAceNone = false;
      }

      if (selectedArbItems.includes('11') && selectedArbItems.length === 1) {
        userMetadata.medicationsArbNone = true;
      } else {
        userMetadata.medicationsArbNone = false;
      }

      props.onClickNext(userMetadata, userAce, userArb);
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const { t } = useTranslation();

  const questionSwitch = getMedicationsQuestionsSwitch(selected, t);

  const onQuestionSelection = val => {
    setSelected(val);
  };

  const noneAceSelected = () => {
    return selectedAceItems.includes('11') && selectedAceItems.length === 1;
  };

  const noneArbSelected = () => {
    return selectedArbItems.includes('11') && selectedArbItems.length === 1;
  };

  const noneAceSaved = () => {
    return (
      context &&
      context.userMetaData &&
      context.userMetaData.medicationsAceNone === true
    );
  };

  const noneArbSaved = () => {
    return (
      context &&
      context.userMetaData &&
      context.userMetaData.medicationsArbNone === true
    );
  };

  const getAceValues = aceValuesObj => {
    if (noneAceSaved()) {
      return ['11'];
    }

    return getAceValuesArr(aceValuesObj);
  };

  const getArbValues = arbValuesObj => {
    if (noneArbSaved()) {
      return ['11'];
    }

    return getArbValuesArr(arbValuesObj);
  };

  const [selectedAceItems, setSelectedAceItems] = useState(
    context && context.userAce ? getAceValues(context.userAce) : []
  );

  const [selectedArbItems, setSelectedArbItems] = useState(
    context && context.userArb ? getArbValues(context.userArb) : []
  );

  const aceQuestions = getAceQuestions(selectedAceItems, t);
  const arbQuestions = getArbQuestions(selectedArbItems, t);

  const onAceCheckboxChange = (val, checked) => {
    if (checked) {
      if (val === '11') {
        setSelectedAceItems([val]);
      } else {
        setSelectedAceItems([...selectedAceItems, val]);
      }
    } else {
      setSelectedAceItems(selectedAceItems.filter(i => i !== val));
    }
  };

  const onArbCheckboxChange = (val, checked) => {
    if (checked) {
      if (val === '11') {
        setSelectedArbItems([val]);
      } else {
        setSelectedArbItems([...selectedArbItems, val]);
      }
    } else {
      setSelectedArbItems(selectedAceItems.filter(i => i !== val));
    }
  };

  return (
    <div>
      <Header />
      {(context == null || context.editMode !== true) && (
        <StepProgressIndicator
          showBasicQuestions={context.showBasicQuestions}
          selectedSlideIx={
            process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 3 : 2
          }
          firstStep
        />
      )}

      <Question
        sectionTitle={t(
          'onboarding.medicationsSection.medicationStep1.question'
        )}
        radioSelection={{ items: questionSwitch, twoColumns: true }}
        onAnswer={val => onQuestionSelection(val)}
      ></Question>

      {selected === '1' && (
        <>
          <Question
            sectionTitle={t(
              'onboarding.medicationsSection.medicationStep2.sectionTitle'
            )}
            checkboxSelection={{ items: aceQuestions, twoColumns: false }}
            deselectAllValue="11"
            onAnswer={(val, checked) => onAceCheckboxChange(val, checked)}
            instructionAbove={t(
              'onboarding.medicationsSection.medicationStep2.instructionAbove'
            )}
          />

          <Question
            sectionTitle={t(
              'onboarding.medicationsSection.medicationStep3.sectionTitle'
            )}
            checkboxSelection={{ items: arbQuestions, twoColumns: false }}
            deselectAllValue="11"
            onAnswer={(val, checked) => onArbCheckboxChange(val, checked)}
            instructionAbove={t(
              'onboarding.medicationsSection.medicationStep3.instructionAbove'
            )}
          />
        </>
      )}

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
        nextButtonDisabled={
          selected === undefined ||
          (selected === '1' &&
            (selectedArbItems.length === 0 || selectedAceItems.length === 0))
        }
        editMode={(context && context.editMode) || context.continueInEditMode}
      />
    </div>
  );
}

export default DiseasesStep5;
